export default "__VITE_ASSET__BhAqyv8___"